import type { VarianteDetaillee } from '@/types/api';

interface Props {
  variante: VarianteDetaillee;
  onChoisir: (variante: VarianteDetaillee) => void;
  desactive?: boolean;
}

/**
 * Une rédaction existante proposée comme point de départ d'un nouveau couple. Toute la
 * carte est cliquable : c'est un `<button>` natif, donc atteignable au clavier (Tab) et
 * activable par Entrée ou Espace. Elle ne contient aucune autre action, pour qu'un clic ne
 * puisse pas en déclencher une autre par erreur.
 */
export function CarteRedactionSource({ variante, onChoisir, desactive }: Props) {
  const intitule = variante.intituleActivite ?? 'Sans intitulé';
  return (
    <button
      type="button"
      className="carte-choix"
      onClick={() => onChoisir(variante)}
      disabled={desactive}
    >
      <span className="carte-choix__titre">{intitule}</span>
      <span className="detail">
        {variante.metiers.length} métier(s), {variante.connaissances.length} domaine(s)
      </span>
      <span className="carte-choix__action" aria-hidden="true">
        Reprendre cette rédaction
      </span>
    </button>
  );
}
